module.exports = __webpack_public_path__ + "img/home.450ccfd1.png";